import React, { Component } from 'react'
import { connect } from 'react-redux'

import { WishlistButton } from 'client/shared/blocks/wishlist-button'

import { addToWishlist } from 'client/bookmate/reducers/book-reducer'
import { show as showAuthPopup } from 'client/shared/reducers/popup-reducer'

import { CurrentUserState } from 'client/shared/types/current-user'
import { BookSerialProps } from 'client/shared/types/resource'
import { Dispatch, State as ConnectedState } from 'shared/types/redux'

type Props = {
  currentUser: CurrentUserState
  book: BookSerialProps
  dispatch: Dispatch
}

type State = {
  wasButtonPressedBeforeLogin: boolean
  loading: boolean
}

class WishlistButtonBox extends Component<Props, State> {
  state = {
    wasButtonPressedBeforeLogin: false,
    loading: false,
  }

  componentDidUpdate(prevProps: Props) {
    const {
      dispatch,
      book,
      currentUser: { auth },
    } = this.props

    if (
      prevProps.currentUser.auth !== auth &&
      this.state.wasButtonPressedBeforeLogin
    ) {
      this.setState({ wasButtonPressedBeforeLogin: false })
      dispatch(addToWishlist(book))
    }
  }

  onButtonClick = async () => {
    const {
      dispatch,
      book,
      currentUser: { auth },
    } = this.props

    if (auth) {
      this.setState({ loading: true })
      await dispatch(addToWishlist(book))
      this.setState({ loading: false })
    } else {
      this.setState({ wasButtonPressedBeforeLogin: true })
      dispatch(showAuthPopup(book))
    }
  }

  render() {
    const { book } = this.props

    return (
      <WishlistButton
        book={book}
        loading={this.state.loading}
        onButtonClick={this.onButtonClick}
      />
    )
  }
}

const wrapper = connect((state: ConnectedState) => ({
  currentUser: state.currentUser,
}))

export default wrapper(WishlistButtonBox)
